import { BPanel, Breadcrumb } from '@sketchpixy/rubix';
import { Link, withRouter } from 'react-router';
import React from 'react';

import { Meteor } from 'meteor/meteor';
import { SimpleSchema } from 'meteor/aldeed:simple-schema';

import { UserSchema } from '../../collections/users/users';
import { createUser } from '../../collections/users/methods';
import MgfForm from '../common/mgfForm';

@withRouter
export default class UserAddPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		this.UserAddSchema = new SimpleSchema([UserSchema, {
			"password": {
				type: String,
				label: "Mot de passe",
				min: 8,
				uniforms: {
					type: "password"
				}
			},
		}]);
	}

	handleSubmit(doc) {
		return new Promise((resolve, reject) => {
			createUser.call({
				username: doc.username,
				email: doc.profile.email,
				password: doc.password,
				profile: doc.profile,
				roles: doc.roles
			}, (error) => {
				if (!error) {
					resolve(doc);
					this.props.router.push('/users');
				}
				reject(error);
			});
		});
	}

	render() {
		return (
			<div>
				<Breadcrumb>
					<Breadcrumb.Item>
						<Link to="/users">Utilisateurs</Link>
					</Breadcrumb.Item>
					<Breadcrumb.Item href="#" active>
						Ajouter un utilisateur
					</Breadcrumb.Item>
				</Breadcrumb>
				<BPanel header="Ajouter un utilisateur">
					<MgfForm schema={this.UserAddSchema} collection={Meteor.users} doSave={false} onSubmit={this.handleSubmit.bind(this)} />
				</BPanel>
			</div>
		);
	}
}




/** WEBPACK FOOTER **
 ** ./src/universal/components/users/UserAdd.page.js
 **/